import type { IconData } from '@stacksjs/iconify-core'

export const feather: IconData = {
  "body": "<path fill=\"currentColor\" d=\"m13.89 10.808l3.616-3.616a3 3 0 0 0-4.243-4.242L11.77 4.444l.598 2.23l.896-.896a1 1 0 1 1 1.415 1.414L11.66 10.21zm-1.633 1.633l-2.23-.598l-2.74 2.74l2.66.169zm-2.12-6.364L5.71 10.502l.163 2.665l4.86-4.86l-.598-2.23zM5.403 16.466L1.95 19.92a1 1 0 0 1-1.414-1.414l3.45-3.45l-.326-5.331l8.19-8.19a5 5 0 1 1 7.07 7.072l-8.198 8.198l-5.318-.34z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default feather
